import { AuthService } from "../service/auth.service";
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { TokenStorageService } from "../service/token-storage.service";
import { Router } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService, 
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // Don't redirect on OTP verification or resend OTP endpoints
          if (!request.url.includes('/verify-otp') && !request.url.includes('/resend-otp')) {
            this.tokenStorage.signOut();
            this.router.navigate(['/authentication/signin']);
          }
        }

        const error = err?.error?.message || err?.statusText || 'An error occured';
        return throwError(() => err);
      })
    );
  }
}
